import { render, staticRenderFns } from "./BrBookEndCover.vue?vue&type=template&id=e6e779f4&"
import script from "./BrBookEndCover.vue?vue&type=script&lang=js&"
export * from "./BrBookEndCover.vue?vue&type=script&lang=js&"
import style0 from "./BrBookEndCover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports